<template>
    <div class="upload-card">
        <div class="upload-wrapper">
            <div class="d-flex justify-content-center align-items-center mb-4 steps-container">
                <div class="step-item step-blue">
                    <span class="step-dot-blue completed"></span>
                    <span class="step-label-blue">Pré-visualização do PDF</span>
                </div>
                <div class="step-line completed"></div>
                <div class="step-item active">
                    <span class="step-dot"></span>
                    <span class="step-label-grey">Anexar PDF Assinado</span>
                </div>
            </div>
        </div>

        <div class="alert-success-custom mb-4">
            <div class="d-flex align-items-center justify-content-center text-center">
                <i class="fa fa-check-circle-o fa-2x mr-3 text-success"></i>
                <span class="text-instruction font-weight-500">
                    Agora que você imprimiu e assinou (fisicamente ou digitalmente) o documento em PDF, <br>
                    faça o upload do arquivo assinado.
                </span>
            </div>
        </div>

        <div v-if="!nomeArquivoExistente" class="d-flex flex-column flex-grow-1 align-items-center w-100">
            <div class="mt-5">
                <i class="fa fa-upload fa-4x text-muted opacity-50"></i>
            </div>

            <div class="mt-5">
                <p class="text-muted">
                    <i class="fa fa-file-pdf-o mr-1"></i>
                    Apenas arquivos em formato PDF são permitidos
                </p>
            </div>
        </div>

        <div class="d-flex flex-grow-1 justify-content-center align-items-center w-100 mb-5">
            <div class="d-flex justify-content-center align-items-center w-100">
                <b-form-file
                    v-model="arquivoSelecionado"
                    :placeholder="nomeArquivoExistente || 'Clique ou arraste o arquivo para selecionar'"
                    :browse-text="nomeArquivoExistente ? 'Substituir Arquivo' : 'Selecionar Arquivo'"
                    drop-placeholder="Solte o arquivo PDF aqui..."
                    accept=".pdf,application/pdf"
                    :disabled="carregando"
                    style="min-width: 400px; max-width: 600px;"
                />

                <b-button
                    v-show="arquivoSelecionado"
                    variant="light"
                    v-b-tooltip.hover
                    title="Limpar arquivo selecionado"
                    @click="arquivoSelecionado = null"
                >
                    <i class="fa fa-times fa-thin text-danger font-weight-bold"></i>
                </b-button>

                <b-button
                    class="ml-3 btn-blue-custom"
                    @click.stop="enviarArquivo"
                    :disabled="desabilitarBtnEnviar"
                    style="min-width: 130px;"
                >
                    <i class="fa fa-upload mr-2"></i>
                    Enviar Arquivo Assinado
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import BoletimMedicaoServicos from '../../../fornecedor/contratos/boletinsMedicoes/BoletimMedicaoServicos'
import { tiposAnexoEnum } from '../../../fornecedor/contratos/boletinsMedicoes/tiposAnexo'

export default {
    name: 'MemoriaCalculoConcluir',
    props: {
        contratoId: {
            type: String,
            default: null
        },
        boletimMedicaoId: {
            type: String,
            default: null
        },
        documentoBoletimMedicaoId: {
            type: [String, Number],
            default: null
        },
        nomeArquivoExistente: {
            type: String,
            default: null
        },
        tipoAnexo: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            arquivoSelecionado: null,
            carregando: false
        }
    },
    computed: {
        desabilitarBtnEnviar() {
            return !this.arquivoSelecionado || this.carregando;
        }
    },
    methods: {
        validarArquivoSelecionado() {
            if (!this.arquivoSelecionado) {
                return false;
            }

            const nomeArquivo = (this.arquivoSelecionado.name || '').toLowerCase();
            const extensaoValida = nomeArquivo.endsWith('.pdf');
            const tipoArquivo = this.arquivoSelecionado.type;
            const tipoValido = !tipoArquivo || tipoArquivo === 'application/pdf';

            if (!extensaoValida || !tipoValido) {
                this.$toast?.error(
                    'Apenas arquivos em formato PDF são permitidos',
                    'Erro',
                    this.$toastConfig?.error || { position: 'topRight', timeout: 5000 }
                );
                this.arquivoSelecionado = null;
                return false;
            }

            return true;
        },
        async enviarArquivo() {
            if (!this.validarArquivoSelecionado()) {
                return;
            }

            this.carregando = true;
            this.$store?.dispatch?.('addRequest');

            try {
                const dto = {
                    tipo: this.tipoAnexo ?? tiposAnexoEnum.MemoriaCalculoAssinadaPeloFornecedor,
                    arquivo: this.arquivoSelecionado
                };

                const response = this.documentoBoletimMedicaoId
                    ? await BoletimMedicaoServicos.atualizarDocumentoBoletimMedicao(
                        this.contratoId,
                        this.boletimMedicaoId,
                        this.documentoBoletimMedicaoId,
                        dto
                    )
                    : await BoletimMedicaoServicos.adicionarDocumentoBoletimMedicao(
                        this.contratoId,
                        this.boletimMedicaoId,
                        dto
                    );

                if (!response || !response.success) {
                    const mensagemErro = response?.errors?.join?.('; ')
                        || 'Não foi possível importar o arquivo selecionado';
                    throw new Error(mensagemErro);
                }

                this.$toast?.success(
                    'Arquivo importado com sucesso!',
                    'OK',
                    this.$toastConfig?.success || { position: 'topRight', timeout: 3000 }
                );

                this.arquivoSelecionado = null;
                this.$emit('arquivo-enviado-sucesso');
            } catch (error) {
                this.$toast?.error(
                    error?.message || 'Não foi possível importar o arquivo selecionado',
                    'Erro',
                    this.$toastConfig?.error || { position: 'topRight', timeout: 5000 }
                );
            } finally {
                this.carregando = false;
                this.$store?.dispatch?.('removeRequest');
            }
        }
    }
}
</script>

<style scoped>
.fa-thin {
    font-weight: 20 !important;
    -webkit-text-stroke: 0.5px white;
}

.b-form-file .custom-file-label::after {
    display: none;
}

.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}

.btn-blue-custom:hover {
    filter: brightness(0.9);
}

.upload-wrapper {
    width: 100%;
}

.upload-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
}

.alert-success-custom {
    background-color: #D3ECE2;
    border-radius: 8px;
    padding: 12px 24px;
    max-width: fit-content;
    margin: 0 auto;
}

.steps-container {
    margin-bottom: 30px;
}

.step-label-blue {
    font-size: 0.9rem;
    font-weight: 600;
    color: #23A26D;
}

.step-label-grey {
    font-size: 0.9rem;
    font-weight: 600;
    color: #0F97C7;
}

.step-item {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #0F97C7;
    font-size: 0.9rem;
}

.step-item.active {
    color: #23A26D;
}

.step-blue {
    color: #23A26D;
}

.step-dot {
    width: 12px;
    height: 12px;
    background-color: #0F97C7;
    border-radius: 50%;
    margin-right: 8px;
}

.step-dot-blue {
    width: 12px;
    height: 12px;
    background-color: #23A26D;
    border-radius: 50%;
    margin-right: 8px;
}

.step-item.active .step-dot {
    background-color: #0F97C7;
}

.step-line {
    width: 60px;
    height: 2px;
    background-color: #dee2e6;
    margin: 0 15px;
}

.step-line.completed {
    background-color: #007bff;
}
</style>
